<template>
  <PageSecondary>
    <template #title>Прошлое</template>
    Я Айтишник-Дизайнер 
    <ul>
      <li>Последние 4 года строил компанию <a href="https://newcrom.com">Newcrom</a>, новейшее оборудование для хроматографии.</li>
      <li>Жил в Америке год.</li>
      <li>3 года посвятил развитию софта для автоматизации зданий с Alphaopen.</li>
      <li>3 года развивал стартап на стыке дополненной реальности, и адаптивной музыки.</li>
      <li>Жил 2 года на Бали и исследовал окрестности.</li>
      <li>2 года создавал графические движки для ситуационных центров оборонки.</li>
      <li>Закончил МГТУ им. Баумана.</li>
      <li>В 13 лет собирал роботов чемпионов на микроконтроллерах и писал игры для начальной школы.</li>
    </ul>
    
    <!--
    Напиши мне о себе <a href="https://t.me/alanverne" target="_blank">в Telegram</a>-->

    <div style="display: none;">
      26ой год я прожил в Чикаго, городе дождей и ветров. Заехал в Нью-Йорк, бурлящий, вонючий и контрастный. Проехал с друзьями по Калифорния-1, купался в водопаде национального парка, гулял среди многовековых елей.

      В штатах меня ждёт прекрасный двухдверный Nissan. Чинил его сам)
      Я питался ужасной Американской кухней, и жарил во дворе божественные стейки.

      Я посмотрел на Американскую мечту иммигрантов, она есть, это спокойная, наивная деревенская жизнь, без роскоши и шика, но при желании впахать - дающая дивиденды и возможность жить жизнь на пенсии.

      В Москве уже месяц и был очень рад отметить день рождения в родном месте. Москва хорошеет. И Москва крута! С радостью увижу всех-всех в центре. Спишемся! Обнимаю!

      Чувствую, 27ой год будет годом рывка и приключения! Пора применить всю накопленную теорию, весь опыт и стартануть до новой высоты!
    </div>
    <div style="display: none;">
      16го июня 2015го я с походным рюкзаком и гитарой за шеей я прилетел на Бали на 2 месяца. Окончательно вернулся через 2 года, в августе 2017го.
      Жаль, осталось всего несколько фотографий в воде. Я любил серфить рано утром и там, где нет людей. Тогда удавалось уединиться и чувствовать только небо и воду вокруг. И всё.

      На Бали я отмечал день рождения на 7 часов раньше.
      Сегодня день рождения наоборот опаздывает. На 8 часов. Я живу в Америке, около озера Мичиган в пригороде Чикаго.

      И тут тоже много особенного.
      И тут тоже всё обычное и всё просто.

      Кто заглянул - крепко обнимаю! и желаю не усложнять и радоваться!

      .
      * Я успел ДО 25 ОКАЗАТЬСЯ В ШТАТАХ!!!

      *** охренеть. двадцать пять.
    </div>
  </PageSecondary>
</template>

<script>
import PageSecondary from "@/components/PageSecondary";
export default {
name: "Past",
  components: {PageSecondary}
}
</script>

<style scoped>

</style>
